<template>
  <div class="container-fluid p-0">
    <div class="row m-0">
      <div class="col-12 p-0">
        <div class="login-card login-dark"
          :style="session.schema_app == 'CLINIC' ? 'background: url(../../assets/bg/bg-clinic.jpg) center center/cover no-repeat;' : 'background: url(../../assets/bg/bg-sistem01.jpg) center center/cover no-repeat;'">
          <div>
            <div class="login-main">
              <form class="theme-form">
                <h2 class="text-center">{{ session.schema_app_title }}</h2>
                <p class="text-center">
                  Enter your email &amp; password to login
                </p>
                <div class="form-group">
                  <label class="col-form-label">Username / Email</label>
                  <input class="form-control" type="email" required v-model="email" placeholder="********@gmail.com" />
                </div>
                <div class="form-group">
                  <label class="col-form-label">Password</label>
                  <div class="form-input position-relative">
                    <input class="form-control" v-model="password" :type="type" name="login[password]" required
                      placeholder="*********" />
                    <div class="show-hide">
                      <span :class="type == 'password' ? 'show' : ''" @click="showPassword">
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group mb-0 checkbox-checked">
                  <!-- <div class="form-check checkbox-solid-info">
                    <input class="form-check-input" id="solid6" type="checkbox" />
                    <label class="form-check-label" for="solid6">Remember password</label>
                  </div> -->
                  <router-link class="link" to="/auth/reset_password">Forgot password?</router-link>
                  <div class="text-end mt-3">
                    <button class="btn btn-primary btn-block w-100" type="button" @click="doLogin" :disabled="isLoading">
                      Sign in
                    </button>
                  </div>
                </div>
                <div class="login-social-title">
                  <h6>Or Sign in with</h6>
                </div>
                <div class="form-group">
                  <ul class="login-social">
                    <li>
                      <a :href="base.BaseProvider() + auth.Google()" target="_self"><i class="icon-google"></i></a>
                    </li>
                    <!-- <li><a href="https://twitter.com" target="_blank"><i class="icon-twitter"></i></a>
                                      </li>
                                      <li><a href="https://www.facebook.com" target="_blank"><i
                                                  class="icon-facebook"></i></a></li>
                                      <li><a href="https://www.instagram.com" target="_blank"><i
                                                  class="icon-instagram"></i></a></li> -->
                  </ul>
                </div>
                <p class="mt-4 mb-0 text-center">
                  Don't have account?<router-link class="ms-2" to="/auth/register">Create Account</router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from "vue";
import { loginRequest } from "@/api/services/AuthRequest";
import * as base from "@/api/endpoint/base";
import * as auth from "@/api/endpoint/auth";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { useRouter } from "vue-router";
let type = ref<string>("password");
let email = ref<string>("");
let password = ref<string>("");
let router = useRouter();

import { useSessionStore } from '@/store/session';
const session = useSessionStore()
onBeforeMount(() => {
  // localStorage.removeItem("user");
});
function showPassword() {
  if (type.value === "password") {
    type.value = "text";
  } else {
    type.value = "password";
  }
}
const isLoading = ref(false)
async function doLogin() {
  isLoading.value = true;
  const resp = await loginRequest({
    username: email.value,
    password: password.value,
  });
  if (resp?.data) {
    await localStorage.setItem("token", resp?.data);
    // await checkRequest();
    router.push("/").then(() => {
      window.location.reload();
    });
  } else {
    toast.error("Opps... Invalid email and password ", {
      position: "top-right",
      autoClose: 2000,
    });
  }
  isLoading.value = false;
}
</script>
